import styled from 'styled-components';

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
  height: ${(props) => props.height || '100%'};
  padding: ${(props) => props.padding || 0};
  background-color: ${(props) => props.backgroundColor || 'transparent'};
  background-image: url(${(props) => props.backgroundImage || 'none'});
  background-size: cover;
`;

export default StyledWrapper;
